<section *ngIf="availableChecks.medicalFood">
  <mat-label>{{ 'classification-check.medicinal-food-prescription' | translate }}</mat-label>
  <button mat-raised-button (click)="setMedicalFood(true)"
          [color]="buttonsColor.medicalFoodYes">{{ 'classification-check.yes-button' | translate }}
  </button>
  <button mat-raised-button (click)="setMedicalFood(false)"
          [color]="buttonsColor.medicalFoodNo">{{ 'classification-check.no-button' | translate }}
  </button>
</section>

<section *ngIf="availableChecks.complementaryMedicine">
  <mat-label>{{ 'classification-check.complimentary-prescription' | translate }}</mat-label>
  <button mat-raised-button (click)="setComplementaryMedicinePrescription(true)"
          [color]="buttonsColor.complementaryMedicinePrescriptionYes">{{ 'classification-check.yes-button' | translate }}
  </button>
  <button mat-raised-button (click)="setComplementaryMedicinePrescription(false)"
          [color]="buttonsColor.complementaryMedicinePrescriptionNo">{{ 'classification-check.no-button' | translate }}
  </button>
</section>

<section *ngIf="availableChecks.complementaryMedicine">
  <mat-label>{{ 'classification-check.complimentary-therapist' | translate }}</mat-label>
  <button mat-raised-button (click)="setComplementaryMedicineTherapist(true)"
          [color]="buttonsColor.complementaryMedicineTherapistYes">{{ 'classification-check.yes-button' | translate }}
  </button>
  <button mat-raised-button (click)="setComplementaryMedicineTherapist(false)"
          [color]="buttonsColor.complementaryMedicineTherapistNo">{{ 'classification-check.no-button' | translate }}
  </button>
</section>

<section *ngIf="availableChecks.behavioralTreatment">
  <mat-label>{{ 'classification-check.behavioral-therapist' | translate }}</mat-label>
  <button mat-raised-button (click)="setBehavioralTreatmentTherapist(true)"
          [color]="buttonsColor.behavioralTreatmentTherapistYes">{{ 'classification-check.yes-button' | translate }}
  </button>
  <button mat-raised-button (click)="setBehavioralTreatmentTherapist(false)"
          [color]="buttonsColor.behavioralTreatmentTherapistNo">{{ 'classification-check.no-button' | translate }}
  </button>
</section>

<ng-container
  *ngIf="!availableChecks || (!availableChecks.medicalFood && !availableChecks.complementaryMedicine && !availableChecks.behavioralTreatment)">
  <h4>{{ 'classification-check.no-checks-available' | translate }}</h4>
</ng-container>
